import React, { useEffect, useState } from "react";

import { errorNotification } from "../../../components/toast-notification/common-toast";
import dayjs from "dayjs";
import { getRequest } from "../../../components/axiosClient";
import { useNavigate } from "react-router-dom";
import { Box, Button } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import CommonDatePicker from "../../CommonDatePicker";
import CustomDataGridTable from "../../../components/common/DataGridTable";
import LoadingSpinner from "../../../components/loader/LoadingSpinner";
import {
  GET_REPORT_COMPLETED_TASK,
  GET_REPORT_TRACK,
} from "../../../components/utils";

const Repotemployeehours = () => {
  // const todayDate = new Date();
  const todayDate = dayjs().format("YYYY-MM-DD");
  const [startDateView, setstartDateView] = useState(null);
  const [endDateView, setendDateView] = useState(null);
  const showActionBar = false;
  // const [endDateView, setendDateView] = useState(todayDate);

  const [getAlltask, setgetAlltask] = useState(null);
  const [getCompletedTask, setCompletedTask] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const getReportAllEmployeetrack = async () => {
    let apiUrl = `${GET_REPORT_TRACK}`;

    if (startDateView) {
      apiUrl = apiUrl + `?start_date=${startDateView}`;
    }
    if (endDateView) {
      apiUrl = apiUrl + `&end_date=${endDateView}`;
    }
    try {
      setLoading(true);
      // let apiUrl = `${GET_REPORT_TRACK}?start_date=${startDateView}&end_date=${endDateView}`;

      const res = await getRequest(apiUrl, null, navigate);

      if (res.data && res.data.data) {
        setgetAlltask(res.data.data);
      }

      //   if (res.data && res.data.data && Array.isArray(res.data.data.page_data)) {
      //     setListAllEmployee(res.data.data.page_data);
      //     setPageInformation(res.data.data.page_information);
      //   } else {
      //     errorNotification(res.errormessage);
      //     setListAllEmployee([]);
      //   }
      setLoading(false);
    } catch (error) {
      errorNotification(error);
      setLoading(false);
    }
  };
  const handleSearch = () => {
    getReportAllEmployeetrack();
  };

  useEffect(() => {
    if (startDateView) {
      getReportAllEmployeetrack();
    }
  }, []);
  const columns = [
    {
      field: "first_name",
      headerName: "First Name",
      width: 150,
    },
    {
      field: "last_name",
      headerName: "Last Name",
      width: 150,
    },
    {
      field: "role",
      headerName: "Role",
      width: 150,
    },
    {
      field: "api_trackers",
      headerName: "Trackers",
      width: 150,
    },
  ];

  const rows = getAlltask?.map((data) => ({
    id: data.id,
    first_name: data.first_name,
    last_name: data.last_name,
    role: data?.role?.name,
    api_trackers: data?.api_trackers[0]?.api_call_count || "--",
  }));

  const handleChangeEndDate = (newDate) => {
    if (newDate) {
      setendDateView(dayjs(newDate).format("YYYY-MM-DD"));
    } else {
      setendDateView(newDate);
    }
  };

  const handleChangeStartDate = (newDate) => {
    if (newDate) {
      setstartDateView(dayjs(newDate).format("YYYY-MM-DD"));
    } else {
      setstartDateView(newDate);
    }
  };

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      height={"100%"}
      width={"100%"}
      disableActionBar={true}
      disabled={true}
    >
      <Box display={"flex"} gap={2} alignItems="center">
        <Box display="flex" flexDirection="column">
          <label
            htmlFor="start-date"
            style={{ fontWeight: "bold", marginBottom: "5px" }}
          >
            Start Date
          </label>

          <CommonDatePicker
            className="common-date-picker"
            placeholder="Select Start Date"
            value={startDateView}
            // disableActionBar={true}
            onChange={(newDate) => handleChangeStartDate(newDate)}
          // onChange={(newDate) =>
          //   setstartDateView(dayjs(newDate).format("YYYY-MM-DD"))
          // }
          />
        </Box>
        <Box display="flex" flexDirection="column">
          <label
            htmlFor="end-date"
            style={{ fontWeight: "bold", marginBottom: "5px" }}
          >
            End Date
          </label>
          <CommonDatePicker
            className="common-date-picker"
            placeholder="Select End Date"
            value={endDateView}
            // disableActionBar={true}
            onChange={(newDate) => handleChangeEndDate(newDate)}
          />
        </Box>
        <Button
          variant="contained"
          sx={{
            bgcolor: "#367a7c",
            "&:hover": {
              bgcolor: "#367a7c",
              opacity: 0.8,
            },
            textTransform: "none",
            height: "40px", // Matches the height of DatePicker
            alignSelf: "flex-end", // Aligns button with DatePicker
          }}
          onClick={handleSearch}
          disabled={!startDateView}
        >
          Search
        </Button>
      </Box>
      <Box flex={1} overflow={"auto"}>
        {loading ? (
          <LoadingSpinner />
        ) : (
          <CustomDataGridTable
            columns={columns}
            rows={rows}
            hideFooter={true}
            unstable_strictMode={false}
          />
        )}
      </Box>
    </Box>
  );
};

export default Repotemployeehours;
